<template>
  <div
    class="spring-spinner"
    style="margin-top: 12px"
    v-if="!thereIsNoOrders && !errorMessage && !orders.length"
  >
    <div class="spring-spinner-part top">
      <div class="spring-spinner-rotator"></div>
    </div>
    <div class="spring-spinner-part bottom">
      <div class="spring-spinner-rotator"></div>
    </div>
  </div>
  <div class="tab-container" @scroll="scroll($event)" v-else-if="orders.length">
    <order-card
      v-for="(item, index) in orders"
      :initData="item"
      :id="item.id"
      :key="index + generateRandomNumber() + forceUpdate"
      :data="item"
      @cancelled="
        orders[findBookingById(item.id)].status = 'PAX_CANCELLED';
        forceUpdate++;
      "
    />
    <div class="spring-spinner" v-if="loading">
      <div class="spring-spinner-part top">
        <div class="spring-spinner-rotator"></div>
      </div>
      <div class="spring-spinner-part bottom">
        <div class="spring-spinner-rotator"></div>
      </div>
    </div>
  </div>
  <div
    class="w-full h-full float-left flex items-center justify-center"
    v-if="errorMessage"
  >
    <p class="w-full text-center mb-16 text-gray">{{ errorMessage }}</p>
  </div>
  <div
    class="w-full h-full float-left flex items-center justify-center"
    v-else-if="thereIsNoOrders"
  >
    <p class="w-full text-center mb-16 text-gray">{{ $t('gnenral.no_orders') }}</p>
  </div>
</template>

<script>
import OrderCard from "@/components/OrderCard.vue";
import socketEventsMixin from "@/mixins/socketEventsMixin";
import axios from "axios";

export default {
  name: "InstantOrders",
  mixins: [socketEventsMixin],
  events() {
    return {
      "Passengers:booking_updated": this.changeOrderStatus,
    };
  },
  components: {
    OrderCard,
  },
  data() {
    return {
      thereIsNoOrders: false,
      orders: [],
      errorMessage: "",
      page: 1,
      lastPage: 0,
      loading: false,
      forceUpdate: 0,
    };
  },
  created() {
    if (!this.orders.length) {
      this.$store
        .dispatch("getOrders", "INSTANT")
        .then((response) => {
          if (response.data.length) {
            this.thereIsNoOrders = false;
            this.lastPage = response.last_page;
            response.data.forEach((el) => {
              this.orders.push(el);
            });
          } else {
            this.thereIsNoOrders = true;
          }
        })
        .catch((error) => {
          this.errorMessage = error;
        });
      // this.axios
      //   .get(`${this.$store.state.rootAPI}besoins-counts`)
      //   .then((res) => {
      //     this.$emit("setTotalNumber", res.data.data);
      //   });
    }
  },
  methods: {
    addToOrders(order) {
      // if (this.orders.length > 0)
      //   for (let i = 0; i < this.orders.length; i++) {
      //     if (this.orders[i].status === "PENDING") {
      //       this.orders.splice(i, 0, order);
      //       break;
      //     }
      //   }
      // else
      console.log("ORDER in add to orders ", order);
      this.orders.unshift(order);
      this.forceUpdate++;
    },
    generateRandomNumber() {
      let num = Math.random().toString();
      return Number.parseInt(num.substring(2, num.length - 1));
    },
    loadData(page) {
      this.$store
        .dispatch("getOrdersPageData", { page: page, time: "INSTANT" })
        .then((response) => {
          response.forEach((el) => {
            this.orders.push(el);
          });
        })
        .catch((error) => {
          this.errorMessage = error;
        })
        .finally(() => {
          this.loading = false;
          this.page++;
        });
    },
    scroll(event) {
      if (
        Math.round(event.target.scrollTop + event.target.offsetHeight) ==
          event.target.scrollHeight &&
        this.page < this.lastPage &&
        !this.loading
      ) {
        this.loading = true;
        this.loadData(this.page + 1);
      }
    },
    array_move(arr, old_index, new_index) {
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr; // for testing
    },
    findBookingById(id) {
      console.log("--- FIND BOOKING ---");
      for (let i = 0; i < this.orders.length; i++) {
        console.log(this.orders[i].id, id);
        if (this.orders[i].id == id) return i;
      }
      console.log("------ END ------");
    },
    changeOrderStatus({ booking_id, status, driver }) {
      
      let index = this.findBookingById(booking_id);

      if (this.orders[index]) {
        if (status == "DONE" || status == "PAID") {
          this.orders.splice(index, 1);
          if (this.orders.length <= 0) this.thereIsNoOrders = true;
        } else if (driver) {
          let reOrder = this.orders[index].status == "PENDING" ? true : false;
          this.orders[index].status = status;
          this.orders[index]["captain_name"] = driver.first_name;
          this.orders[index]["taxi_number"] = driver.username;
          this.orders[index]["captain_phone_number"] = driver.phone_number;
          this.orders[index]["car_brand_model"] = driver.car_brand_model;
          this.orders[index]["car_brand"] = driver.car_brand;
          this.orders[index]["car_color"] = driver.car_color;
          this.orders[index]["car_plate_number"] = driver.car_plate_number;
          this.orders[index].datetime = driver.datetime;
          if (reOrder) {
            let newOrder = this.orders.filter(
              (a) => a.status == "PENDING"
            ).length;
            this.array_move(this.orders, index, newOrder);
            // this.$emit("decreaseCount");
          }
        } else {
          this.orders[index].status = status;
        }
        this.forceUpdate++;
      }
    },
    move() {
      this.orders[0].status = "APPROVED";
      this.orders[0]["captain_name"] = "It's meeee";
      console.log("2", this.orders);
    },
  },
  // watch: {
  //   // orders(newArr) {
  //   //   this.orders.length = 0;
  //   //   this.orders.concat(newArr);
  //   // }
  // }
};
</script>

<style lang="scss" scoped>
.tab-container {
  width: 100%;
  height: 100%;
  float: left;
  overflow-y: overlay;
  padding: 22px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.tab-container::-webkit-scrollbar {
  width: 0.2em;
}

.tab-container::-webkit-scrollbar-track {
  background-color: transparent;
}

.tab-container::-webkit-scrollbar-thumb {
  background-color: #c1c5d8;
  border-radius: 9999px;
}

.floating-button {
  z-index: 999;
  float: left;
  border-radius: 100%;
  width: 64px;
  height: 64px;
  position: absolute;
  bottom: 0;
  left: 0;
}
</style>
